import ServiceDistriRule from '@components/LocalMerchant/ServiceDistriRule'

export default {
  path: 'serviceDistriRule',
  component: ServiceDistriRule,
  stat: '员工系统/使用帮助'
}
